import React, { useEffect, useState } from "react";
import { PlusOutlined, DeleteOutlined, CloseOutlined, CheckOutlined, EditOutlined, ExpandAltOutlined } from '@ant-design/icons';
import { Modal, Col, Row, Table, Button, Card, Form, FormInstance, Input, Checkbox, DatePicker, Space, Spin, Tag } from 'antd';
import dayjs from 'dayjs';
import { AlignType } from 'rc-table/lib/interface';

import TipoCertificadoDocumento from "../Componentes/TipoCertificadoDocumento"
import { errorMessage, mostrarInfo } from "../../../utils/messages";
import { disabledDate, hasText } from "../../../utils/utilsFunctions";
import { ITipocertificado, IcheckboxGroupOptions, IDocumentoTipoCertificado, IAreaTipoCertificado, IAreaCertificadora } from "../Componentes/InterfaceCertificadoras";
import { lista_areas_certificadoras } from "../../../config/Contantes";

type CheckboxValueType = string | number | boolean;

interface IProps {
  form: FormInstance<any>;
  tipoCertificados: ITipocertificado[];
  setTipoCertificados: React.Dispatch<React.SetStateAction<ITipocertificado[]>>;
  manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar;
  areasCertificadoras: IAreaCertificadora[];
}


const { TextArea } = Input;


const CertificadorasTipoCertificado = ({ form, tipoCertificados, setTipoCertificados, manter, areasCertificadoras }: IProps) => {
  const [tipoCertificadoDocumentos, setTipoCertificadoDocumentos] = useState<IDocumentoTipoCertificado[]>([]);
  const [allAreasTipoCertificado, setAllAreasTipoCertificado] = useState<IAreaTipoCertificado[]>([]);
  const [checkedAreasTipoCertificado, setCheckedAreasTipoCertificado] = useState<CheckboxValueType[]>([]);
  const [areasTipoCertificado, setAreasTipoCertificado] = useState<IAreaTipoCertificado[]>([]);

  const [checkboxGroupOptions, setCheckboxGroupOptions] = useState<IcheckboxGroupOptions[]>(lista_areas_certificadoras);

  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");
  const [isDtFimDisabled, setIsDtFimDisabled] = useState(false);
  const [isDefaultChecked, setIsDefaultChecked] = useState(false);

  const [estadoModal, setEstadoModal] = useState(1); // 1 : Modal em modo inserção / 2 : Modal em modo detalhe /  3 : Modal em modo edição
  const [exibirModalEx, setExibirModalEx] = useState(false);
  const [exibirTipoCertificadoCadastrada, setExibirTipoCertificadoCadastrada] = useState("none");
  const [exibirElementoAcaoAlteracao, setExibirElementoAcaoAlteracao] = useState("inline");
  const [dadosValidados, setDadosValidados] = useState(false);


  useEffect(() => {
    if (tipoCertificados.length === 0) {
      setExibirTipoCertificadoCadastrada("none")
    } else {
      setExibirTipoCertificadoCadastrada("inline")
    }
  }, [tipoCertificados]);

  useEffect(() => {
    if (manter === 2 || manter === 9) { // Detalhar
      setExibirElementoAcaoAlteracao("none");
    } else {
      setExibirElementoAcaoAlteracao("inline");
    }
  }, [manter]);


  useEffect(() => {
    // CONFIGURA MODAL PARA ABRIR
    if (estadoModal === 3) { // EM EDIÇÃO
      setIsDefaultChecked(form?.getFieldValue("boTrabalhoAtual"));
      setIsDtFimDisabled(form?.getFieldValue("boTrabalhoAtual"));
    } else if (estadoModal === 2) { // EXIBIR DETALHES
      setIsDefaultChecked(form?.getFieldValue("boTrabalhoAtual"));
      setIsDtFimDisabled(form?.getFieldValue("boTrabalhoAtual"));
    }
  }, [estadoModal]);

  useEffect(() => {
    const updatedAreas: IAreaTipoCertificado[] = checkedAreasTipoCertificado.map(csArea => {
      const existing = allAreasTipoCertificado.find(area => area.csArea === csArea);
      if (existing) {
        return existing;
      }
      // If not found, create a new object with default values
      return {
        csArea,
        statusReg: 1,    // Example default status
        touched: true,
        emEdicao: manter === 3 ? true : false,
      };
    });

    setAreasTipoCertificado(updatedAreas);
  }, [checkedAreasTipoCertificado, allAreasTipoCertificado]);

  useEffect(() => {
    // Somente ficam habilitadas para edição as áreas de tipos de certificados que que estão previamente selecionadas em certificadoras.
    const enabledValues = areasCertificadoras
      .map(area => area.csArea?.toString())
      .filter(Boolean); // Remove undefined/null

    const updatedOptions = checkboxGroupOptions.map(option => ({
      ...option,
      disabled: !enabledValues.includes(option.value)
    }));

    setCheckboxGroupOptions(updatedOptions);
  }, [areasCertificadoras]);


  const controleDaGrid = (botao: string) => {
    if (manter !== 2 && !hasText(form.getFieldValue("dtReconhecimento"))) {
      mostrarInfo("Não é possível incluir novo certificado", "Data de reconhecimento da certificadora ainda não informada");
    } else if (manter !== 2 && areasCertificadoras.length === 0 && manter === 3) {
      mostrarInfo("Não é possível incluir novo certificado", "Selecione pelo menos uma área de atuação para a certificadora");
    } else {
      if (botao === "cancelar") {
        setExibirModalEx(false);
        setExibirElementoAcaoAlteracao("inline");
      } else if (botao === "incluir") {
        setExibirModalEx(false);
        setExibirElementoAcaoAlteracao("inline");
      } else {
        setExibirModalEx(true);
        setExibirElementoAcaoAlteracao("none");
      }
    }

    if (manter === 2) { // Estamos no modo Detalhar
      setExibirElementoAcaoAlteracao("none");
    }
  };

  const [dtCancelamentoTipoCertificadoIncluida, setDtCancelamentoTipoCertificadoIncluida] = useState(false);

  function verificaDtCancelamento() {
    let ret = false;
    if (dtCancelamentoTipoCertificadoIncluida) {
      // Verifica se existe um novo documento do tipo nota técnica
      tipoCertificadoDocumentos.forEach((e: IDocumentoTipoCertificado) => {
        if (e.statusReg === 1 && e.nmDocumento?.toUpperCase() === "NOTA TÉCNICA" && e.idTpCertificadoDocumento === -1) {
          ret = true;
        }
      });
    } else {
      ret = true;
    }
    return ret;
  }

  const validarTipoCertificado = () => {
    if (!verificaDtCancelamento()) {
      mostrarInfo("Campos inconsistentes", "A inclusão da data de cancelamento de tipo de certificado exige também a inclusão de uma nova nota técnica.");
    } else if (checkedAreasTipoCertificado.length === 0) {
      mostrarInfo("Campo inválido", "Selecione pelo menos uma área.");
    } else {
      form
        .validateFields([
          "nmCertificado",
          "teCodigo",
          "teDetalhamento",
          "dtReconhecimentoCertificado",
          "teDetalhamento",
          "dtCancelamentoCertificado",
        ])
        .then(() => {
          setDadosValidados(true);
          controleDaGrid("incluir");
          setDadosTipoCertificado();
          // successMessage(estadoModal === 3 ? "Tipo Certificado Alterado" : "Tipo Certificado Incluído");
        })
        .catch((error) => {
          if (!dadosValidados) {
            errorMessage("Campo obrigatório não preechido ou não validado");
          } else {
            errorMessage(error.message);
          }
          setDadosValidados(false);
        });
    }
  };

  const setDadosTipoCertificado = () => {

    if (estadoModal === 3) { // ESTADO EDIÇÃO DE REGISTROS
      setTipoCertificados(pre => {
        return pre.map(exp => {
          if (exp.emEdicao) {
            return ({
              idTpCertificado: estadoModal === 3 ? Number(form?.getFieldValue("idTpCertificado")) : -1,
              nmCertificado: form?.getFieldValue("nmCertificado")?.toUpperCase(),
              teCodigo: form?.getFieldValue("teCodigo")?.toUpperCase(),
              teDetalhamento: form?.getFieldValue("teDetalhamento")?.toUpperCase(),
              dtReconhecimento: form?.getFieldValue("dtReconhecimentoCertificado") ? dayjs(form?.getFieldValue("dtReconhecimentoCertificado")).format("YYYY-MM-DD") : "",
              dtCancelamento: form?.getFieldValue("dtCancelamentoCertificado") ? dayjs(form?.getFieldValue("dtCancelamentoCertificado")).format("YYYY-MM-DD") : "",
              areas: areasTipoCertificado.map((e: IAreaTipoCertificado) => {
                return ({
                  ...e
                })
              }),
              documentos: tipoCertificadoDocumentos.map((e: IDocumentoTipoCertificado) => {
                return {
                  ...e
                };
              }),
              statusReg: 1,
              touched: true,
              emEdicao: false,
            })
          } else {
            return exp
          }
        })
      });
    } else {
      setTipoCertificados([
        ...tipoCertificados,
        {
          idTpCertificado: estadoModal === 3 ? Number(form?.getFieldValue("idTpCertificado")) : -1,
          nmCertificado: form?.getFieldValue("nmCertificado")?.toUpperCase(),
          teCodigo: form?.getFieldValue("teCodigo"),
          teDetalhamento: form?.getFieldValue("teDetalhamento")?.toUpperCase(),
          dtReconhecimento: form?.getFieldValue("dtReconhecimentoCertificado") ? dayjs(form?.getFieldValue("dtReconhecimentoCertificado")).format("YYYY-MM-DD") : "",
          dtCancelamento: form?.getFieldValue("dtCancelamentoCertificado") ? dayjs(form?.getFieldValue("dtCancelamentoCertificado")).format("YYYY-MM-DD") : "",
          areas: areasTipoCertificado.map((e: IAreaTipoCertificado) => {
            return ({
              ...e
            })
          }),
          documentos: tipoCertificadoDocumentos.map((e: IDocumentoTipoCertificado) => {
            return {
              ...e
            };
          }),
          statusReg: 1,
          emEdicao: false,
          touched: true,
        },
      ]);
    }
    limpaDados();
    setEstadoModal(1); // SETA O MODAL PARA INCLUSÃO (MODO PADRÃO).
  }

  const limpaDados = () => {
    form.resetFields([
      "nmCertificado",
      "teCodigo",
      "dtReconhecimentoCertificado",
      "teDetalhamento",
      "dtCancelamentoCertificado",
    ]);
    setTipoCertificadoDocumentos([]);
    setCheckedAreasTipoCertificado([]);
    setAllAreasTipoCertificado([]);
    setAreasTipoCertificado([]);
    setDtCancelamentoTipoCertificadoIncluida(false);
  }

  const setFieldsDetalharEditar = (tipoCertificado: ITipocertificado) => {
    //console.log(tipoCertificados);
    form.setFieldsValue({
      "idTpCertificado": tipoCertificado.idTpCertificado,
      "nmCertificado": tipoCertificado.nmCertificado,
      "teCodigo": tipoCertificado.teCodigo ? tipoCertificado.teCodigo : undefined,
      "teDetalhamento": tipoCertificado.teDetalhamento,
      "dtReconhecimentoCertificado": tipoCertificado.dtReconhecimento ? dayjs(tipoCertificado.dtReconhecimento) : undefined,
      "dtCancelamentoCertificado": tipoCertificado.dtCancelamento ? dayjs(tipoCertificado.dtCancelamento) : undefined,
      "tipoCertificadoCanceladoNaBase": tipoCertificado.canceladoNaBase,
    });

    setCheckedAreasTipoCertificado(
      tipoCertificado.areas.map((area: IAreaTipoCertificado) => {
        return area.csArea ? area.csArea.toString() : 0
      })
    )

    setAreasTipoCertificado(tipoCertificado.areas);
    setAllAreasTipoCertificado(tipoCertificado.areas);


    setTipoCertificadoDocumentos(tipoCertificado.documentos);

  }

  const columns = [
    {
      // width: 200,
      key: "1",
      title: "Código",
      dataIndex: "",
      render: (ITipoCertificado: ITipocertificado) => <>{ITipoCertificado.teCodigo ? ITipoCertificado.teCodigo.toUpperCase() : undefined}</>,
    },
    {
      // width: 200,
      key: "2",
      title: "Nome",
      dataIndex: "",
      render: (ITipoCertificado: ITipocertificado) => <>{ITipoCertificado.nmCertificado}</>,
    },
    {
      width: 80,
      key: "3",
      title: "Situação",
      dataIndex: "",
      render: (ITipoCertificado: ITipocertificado) => (
        <>
          <Tag hidden={manter === 9} color={ITipoCertificado.canceladoNaBase ? "volcano" : "geekblue"} key={ITipoCertificado.idTpCertificado}>
            {ITipoCertificado.idTpCertificado !== -1 ? (ITipoCertificado.canceladoNaBase ? "INATIVO" : "ATIVO") : ""}
          </Tag>
        </>
      ),
    },
    {
      // width: 200,
      key: "4",
      title: "Data Reconhecimento",
      dataIndex: "",
      render: (ITipoCertificado: ITipocertificado) => <>{dayjs(ITipoCertificado.dtReconhecimento).format("DD/MM/YYYY")}</>,
    },
    {
      // width: 200,
      key: "5",
      title: "Data Cancelamento",
      dataIndex: "",
      render: (ITipoCertificado: ITipocertificado) => <>{ITipoCertificado.dtCancelamento ? dayjs(ITipoCertificado.dtCancelamento).format("DD/MM/YYYY") : undefined}</>,
    },
    {
      key: "9",
      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (ITipoCertificado: ITipocertificado) => (
          <Space style={{justifyContent: 'center'}}>
            <div style={{ display: manter === 2 || manter === 9 ? "inline" : "none" }}>
              <ExpandAltOutlined
                title="Detalhar"
                style={{ color: "blue", marginLeft: 12 }}
                onClick={() => {
                  setEstadoModal(2); // SET O MODO DETALHAR
                  controleDaGrid("detalhar");
                  setFieldsDetalharEditar(ITipoCertificado);
                }}
              />
            </div>

            <div style={{ display: manter === 9 ? "none" : (manter === 1 ? "inline" : exibirElementoAcaoAlteracao) }}>
              <EditOutlined
                title="Editar"
                style={{ color: "blue", marginLeft: 12 }}
                onClick={() => {
                  setEstadoModal(3); // SET O MODO EDIÇÃO
                  controleDaGrid('editar');
                  setFieldsDetalharEditar(ITipoCertificado);
                  // ALTERA CAMPOS DO DATASET PARA REFLETIR O ESTADO DE EDIÇÃO
                  tipoCertificados.forEach(tpCert => {
                    if (tpCert === ITipoCertificado) {
                      tpCert.touched = true;
                      tpCert.emEdicao = estadoModal === 3 ? true : false;
                    } else {
                      tpCert.emEdicao = false;
                    }
                  })
                  ITipoCertificado.emEdicao = true;
                }}
              />

              <DeleteOutlined
                title="Exluir"
                style={{ color: "red", display: (ITipoCertificado?.idTpCertificado && ITipoCertificado?.idTpCertificado < 0) ? "inline" : "none" }} // EXCLUSÃO DE REGISTRO SENDO INSERIDO NO PROCESSO DE ALTERAÇÃO. OU SEJA. QUE AINDA NÃO ESTÁ NA BASE
                onClick={() => {
                  setTipoCertificados(tipoCertificados.filter((tipoCertificado) => tipoCertificado !== ITipoCertificado));
                }}
              />
            </div>
          </Space>
      ),
    },

  ];

  const handleCancel = () => {
    setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO. MODO PADRÃO
    controleDaGrid("cancelar");
    form.resetFields([
      "idTpCertificado",
      "nmCertificado",
      "teCodigo",
      "dtReconhecimentoCertificado",
      "teDetalhamento",
      "dtCancelamentoCertificado",
    ]);
  };

  const onChange = (checkedValues: CheckboxValueType[]) => {
    setCheckedAreasTipoCertificado(checkedValues);
  };


  return (
    <>
      <Button
        style={{ display: exibirElementoAcaoAlteracao }}
        id="incluirTipoCertificado"
        type="primary"
        shape="round"
        onClick={() => {
          limpaDados();
          setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO.
          controleDaGrid("incluirTipoCertificado");
        }}
        icon={<PlusOutlined />}
      >
        Incluir Certificado
      </Button>

      <>
        <Modal title="Certificado" open={exibirModalEx}
          style={{ top: 20 }}
          destroyOnHidden={true}
          width={700}
          closable={false}
          footer={[
            <Button icon={<CloseOutlined />} shape="round" key="cancelFechar" onClick={handleCancel}>
              {estadoModal === 2 ? "Fechar" : "Cancelar"}
            </Button>,
            <Button icon={<CheckOutlined />} shape="round" style={{ display: estadoModal === 2 ? "none" : "inline" }}
              key="ok" type="primary" onClick={validarTipoCertificado}>
              {estadoModal === 3 ? "Alterar" : "Incluir"}
            </Button>,
          ]}
        >
          <Spin spinning={loading} tip={tipLoading}>
            <>
              <Row>
                <Col xs={24} sm={12}>
                  <Form.Item label='Nome do Certificado'
                    name='nmCertificado'
                    colon={false}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Input
                      maxLength={100}
                      disabled={manter === 2 || manter === 9 ? true : false}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={10}>
                  <Form.Item label='Código'
                    labelCol={{ span: 12 }}
                    labelAlign="left"
                    name='teCodigo'
                    colon={false}
                  >
                    <Input
                      disabled={manter === 2 || manter === 9 ? true : false}
                      maxLength={20}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col xs={24} sm={4} style={{ display: estadoModal === 1 ? 'none' : 'inline' }} >
                  <Form.Item label='Situação'
                    colon={false}
                    style={{ flexDirection: "column", alignItems: "flex-start" }}

                  >
                    <Tag color={form?.getFieldValue("tipoCertificadoCanceladoNaBase") ? "volcano" : "geekblue"} >
                      {form?.getFieldValue("idTpCertificado") !== -1 ? (form?.getFieldValue("tipoCertificadoCanceladoNaBase") ? "INATIVO" : "ATIVO") : ""}
                    </Tag>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8}>
                  <Form.Item label="Data do Reconhecimento"
                    name="dtReconhecimentoCertificado"
                    colon={false}
                    style={{ flexDirection: "column", alignItems: "flex-start" }}
                    rules={[
                      {
                        required: true,
                        message: "Campo obrigatório",
                      },
                      {
                        validator: async (_, endDatetime) => {
                          // console.log(form.getFieldValue("dtReconhecimento"));
                          // console.log(endDatetime);
                          let startDatetime = form.getFieldValue("dtReconhecimento");
                          if (startDatetime) {
                            if (dayjs(endDatetime).format("YYYY-MM-DD") < dayjs(startDatetime).format("YYYY-MM-DD")) {
                              return Promise.reject(
                                "Data de reconhecimento do certificado deve ser maior ou igual à data de reconhecimento da certificadora"
                              );
                            }
                          }
                        },
                      },
                    ]}
                  >
                    <DatePicker
                      disabled={manter === 2 || manter === 9 ? true : false}
                      format={"DD/MM/YYYY"}
                      style={{ width: "100%" }}
                      placeholder="Selecionar Data"
                      disabledDate={disabledDate}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={8} style={{ display: manter && manter >= 2 ? 'inline' : 'none' }}>
                  <Form.Item label="Data do Cancelamento"
                    name="dtCancelamentoCertificado"
                    colon={false}
                    style={{ flexDirection: "column", alignItems: "flex-start" }}
                    rules={[
                      {
                        validator: async (_, endDatetime) => {
                          let startDatetime = dayjs(form.getFieldValue("dtReconhecimentoCertificado"));
                          if (startDatetime) {
                            if (endDatetime < startDatetime) {
                              return Promise.reject(
                                "Data de cancelamento do certificado deve ser maior ou igual à data de reconhecimento"
                              );
                            }
                          }
                        },
                      },
                    ]}
                  >
                    <DatePicker
                      // onChange={() => { setDtCancelamentoTipoCertificadoIncluida(true) }}
                      onChange={(date, dateString) => {
                        if (dateString === "") {
                          setDtCancelamentoTipoCertificadoIncluida(false)
                        } else {
                          setDtCancelamentoTipoCertificadoIncluida(true)
                        }
                      }}
                      disabled={manter === 2 || manter === 9 ? true : false}
                      format={"DD/MM/YYYY"}
                      style={{ width: "100%" }}
                      placeholder="Selecionar Data"
                      disabledDate={disabledDate}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Card title={"Áreas"}>
                <Checkbox.Group disabled={manter === 2 || manter === 9 ? true : false} options={checkboxGroupOptions} value={checkedAreasTipoCertificado} onChange={onChange} />
              </Card>

              <br/>
              <Row>
                <Col xs={24} sm={24}>
                  <Form.Item label='Detalhamento'
                    labelCol={{ span: 24 }}
                    name='teDetalhamento'
                  >
                    <TextArea rows={4}
                      placeholder='Detalhamento'
                      // maxLength={100} 
                      disabled={estadoModal === 2 || manter === 9}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Card title="Documentação" variant="borderless" style={{ width: "100%" }}>
                <>
                  <TipoCertificadoDocumento
                    documentos={tipoCertificadoDocumentos}
                    setDocumentos={setTipoCertificadoDocumentos}
                    form={form}
                    manter={manter}
                  />
                </>

              </Card>

            </>
          </Spin>
        </Modal>

      </>

      <Row style={{ display: exibirTipoCertificadoCadastrada }}>
        <Col
          xs={24}
          xl={24}
          style={{ paddingLeft: 16, paddingRight: 16, marginBottom: 20 }}
        >
          <Table size="small" columns={columns} dataSource={tipoCertificados} pagination={false} />
        </Col>
      </Row>

    </>
  )
};

export default CertificadorasTipoCertificado;